import React from "react";
import { profile } from "../data/content";

export default function Footer() {
  return (
    <footer
      style={{
        position: "relative",
        zIndex: 1,
        borderTop: "1px solid var(--border)",
        padding: "36px 0",
        background: "rgba(5,5,8,0.6)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
      }}
    >
      <div
        className="container footer-inner"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}
      >
        <span style={{ fontSize: 13, color: "var(--text-dim)" }}>
          &copy; {new Date().getFullYear()} {profile.name}. Built with React, Three.js &amp; Framer Motion.
        </span>
        <span style={{ fontSize: 13, color: "var(--text-dim)", fontFamily: "var(--font-mono)" }}>
          Engineer Codewala
        </span>
      </div>
    </footer>
  );
}
